import {useEffect, useRef} from 'react';

/**
 * Frische-Poll des Auftrags-Editors (Original `startMetaPoll` 2004,
 * `checkStale` 2036).
 *
 * Alle 25 Sekunden wird nur die Belegversion geholt — der leichteste
 * verfügbare Abruf. Er pausiert, wenn der Reiter im Hintergrund liegt oder
 * gerade gespeichert wird: im Hintergrund nützt die Meldung niemandem, und
 * während des Speicherns ändert sich die Version durch den eigenen Vorgang.
 *
 * Die Prüfung selbst liegt bewusst beim Aufrufer (`onTick`), weil nur dort
 * bekannt ist, ob eigene Änderungen offen sind.
 *
 * @param {boolean} enabled
 * @param {() => void | Promise<void>} onTick
 * @param {number} [intervalMs=25000]
 */
export default function useDocMetaPoll(enabled, onTick, intervalMs = 25000) {
    const tickRef = useRef(onTick);
    tickRef.current = onTick;

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const timer = window.setInterval(() => {
            if (typeof document !== 'undefined' && document.hidden) {
                return;
            }
            Promise.resolve(tickRef.current()).catch(() => {
                // Poll-Fehler bleiben ohne Folge — beim nächsten Durchlauf
                // wird es erneut versucht.
            });
        }, intervalMs);

        return () => window.clearInterval(timer);
    }, [enabled, intervalMs]);
}
